import i18next from "i18next";
import { myAxios } from "./axios";

// login

export function login(data) {
  const config = {
    headers: {
      "Accept-language": i18next.language,
    },
  };
  return myAxios.post("/auth/login", data, config);
}

// 2Fa

export function setup2Fa(data) {
  return myAxios.post("/2fa/setup", data);
}

export function remove2Fa(data) {
  return myAxios.post("/2fa/remove", data);
}

export function verify2Fa(data) {
  return myAxios.post("/2fa/verify", data);
}

export function verifyAuth(data) {
  return myAxios.post("/auth/verify", data);
}

// forgot password

export function forgotPassword(data) {
  return myAxios.post("/auth/forget-password", data);
}

export function resetPassword(data) {
  return myAxios.post("/admins/reset-password", data);
}
